import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';

export interface UserNameProps {
  first?: string;
  last?: string;
}

/** A circle with the first letter of the user's first and last name, followed by the full name. */
export const UserName = ({ first, last }: UserNameProps) => {
  if (!first && !last) return null;

  return (
    <div {...stylex.props(styles.root)}>
      <div {...stylex.props(styles.initials)}>
        {first?.substring(0, 1)}
        {last?.substring(0, 1)}
      </div>
      {first} {last}
    </div>
  );
};

const styles = stylex.create({
  root: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  initials: {
    marginRight: 5,
    display: 'flex',
    height: 30,
    minHeight: 30,
    width: 30,
    minWidth: 30,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: colors.accentPressed,
    color: colors.white,
    fontSize: 'small',
    textAlign: 'center',
  },
});
